export default __webpack_public_path__ + "static/media/gallery_22.bdd8b8bf.jpg";